import "./App.css";
import RequirementForm from "./form/form";
import logo from "./images/wdc-logo.png";

function App() {
  return (
    <main className="relative min-h-screen overflow-hidden bg-wdc-cream">
      {/* Subtle dotted backdrop */}
      <div
        aria-hidden
        className="bg-grid pointer-events-none absolute inset-0 opacity-60"
      />
      {/* Top accent stripe */}
      <div
        aria-hidden
        className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-wdc-orange via-wdc-orange-bright to-wdc-orange-deep"
      />

      <div className="relative mx-auto flex min-h-screen max-w-5xl flex-col px-5 py-8 sm:px-8 sm:py-10">
        {/* Header */}
        <header className="flex items-center justify-between gap-6">
          <img
            src={logo}
            alt="Web Design Collective"
            className="h-9 w-auto sm:h-10"
          />
          <div className="hidden text-right text-[11px] font-semibold uppercase tracking-[0.18em] text-wdc-charcoal/70 sm:block">
            Project Brief
            <br />
            <span className="text-wdc-orange-deep">New Website</span>
          </div>
        </header>

        {/* Form */}
        <div className="flex flex-1 flex-col justify-center py-10 sm:py-14">
          <RequirementForm />
        </div>

        {/* Footer */}
        <footer className="border-t border-wdc-line pt-6 text-center text-[12px] text-wdc-charcoal/60">
          <span>© {new Date().getFullYear()} </span>
          <a
            className="text-wdc-charcoal/80 underline-offset-2 hover:text-wdc-orange-deep hover:underline"
            href="http://webdesigncollective.com.au"
          >
            Web Design Collective
          </a>
          <span> · </span>
          <a
            className="text-wdc-charcoal/80 underline-offset-2 hover:text-wdc-orange-deep hover:underline"
            href="https://connectivai.com"
          >
            ConnectivAI
          </a>
          <span className="ml-2 text-wdc-charcoal/40">v3.0.0</span>
        </footer>
      </div>
    </main>
  );
}

export default App;
